module.exports = __webpack_public_path__ + "assets/img/sub-type-5.7f4f1452.svg";